import Repository from "@/services/repository";

export default {
  createSearch(studyId, request) {
    return Repository.post(`/a/${studyId}/keywords_search.json`, request).then(
      (response) => response.data
    );
  },
};
